export default {
    CASE_NUMBER: str =>
        // Adapted from https://pcl.uscourts.gov/js/validate.js,
        // ignoring leading and trailing spaces since our API gets rid of those
        // keep in sync with CGI::Untaint::case_no
        /^\s*((\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]+(\d{1,5})|(\d{1})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D \:]+(\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]+(\d{1,5})|(\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]*([\w\s]{1,2})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]*(\d{1,5})|(\d{1})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D \:](\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]*([\w\s]{1,2})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]*(\d{1,5}))\s*$/
            .test(str)
    ,
    CASE_NUMBER_WILDCARD: str =>
        // Case lookup form: validation: wildcard.
        /^\s*((\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]+\*|(\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]+(\d{1,5})|(\d{1})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D \:]+(\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]+(\d{1,5})|(\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]*([\w\s]{1,2})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]*(\d{1,5})|(\d{1})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D \:](\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]*([\w\s]{1,2})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]*(\d{1,5}))\s*$/
            .test(str)
    ,
    SSN_OR_TIN: str =>
        // keep in sync with CGI::Untaint::ssntin
        /^\s*(\d{3}-\d{2}-\d{4}|\d{2}-\d{7}|\d{9})\s*$/
            .test(str)
    ,
    SSN4: str =>
        // keep in sync with CGI::Untaint::ssn4
        /^\s*(\d{4})\s*$/
            .test(str)
    ,
    PARTY_NAME_CASE_TITLE: str =>
        // keep in sync with CGI::Untaint::text
        /^\s*([a-z0-9\s\.&\*,'-]+?)\s*$/i
            .test(str)
    ,

};



/** WEBPACK FOOTER **
 ** ./src/components/search/validations/index.js
 **/